import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';

// Solutions pages
import Solutions from './pages/solutions/Solutions';
import ITTechnology from './pages/solutions/ITTechnology';
import Healthcare from './pages/solutions/Healthcare';
import Manufacturing from './pages/solutions/Manufacturing';
import FinancialServices from './pages/solutions/FinancialServices';
import Retail from './pages/solutions/Retail';
import Education from './pages/solutions/Education';
import Ecommerce from './pages/solutions/Ecommerce';
import Insurance from './pages/solutions/Insurance';

// Company pages
import About from './pages/About';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Blog from './pages/Blog';

// Resources pages
import CaseStudies from './pages/resources/CaseStudies';
import WhitePapers from './pages/resources/WhitePapers';
import Webinars from './pages/resources/Webinars';
import Documentation from './pages/resources/Documentation';

// Legal pages
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';

import Features from './pages/Features';

import './styles/main.scss';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Solutions routes */}
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/it-technology" element={<ITTechnology />} />
            <Route path="/solutions/healthcare" element={<Healthcare />} />
            <Route path="/solutions/manufacturing" element={<Manufacturing />} />
            <Route path="/solutions/financial-services" element={<FinancialServices />} />
            <Route path="/solutions/retail" element={<Retail />} />
            <Route path="/solutions/education" element={<Education />} />
            <Route path="/solutions/ecommerce" element={<Ecommerce />} />
            <Route path="/solutions/insurance" element={<Insurance />} />
            
            {/* Company routes */}
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            
            {/* Resources routes */}
            <Route path="/resources/case-studies" element={<CaseStudies />} />
            <Route path="/resources/white-papers" element={<WhitePapers />} />
            <Route path="/resources/webinars" element={<Webinars />} />
            <Route path="/resources/documentation" element={<Documentation />} />
            
            {/* Legal routes */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />

            <Route path="/features" element={<Features />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 